<ng-select
  #ngSelect
  [items]="projects"
  bindLabel="name"
  bindValue="id"
  [(ngModel)]="selectedProjectId"
  (close)="ngSelect.blur()"
  (change)="select($event)"
  [clearable]="false"
  (open)="selectOpen = true"
  (close)="selectOpen = false"
  [selectOnTab]="true"
  placeholder="Projects"
>
  <ng-template ng-label-tmp="ng-label-tmp" let-item="item">
    <button class="btn" type="button">
      <span class="text-muted" [hidden]="!selectOpen">Search projects...</span>
      <span class="text-truncate" [hidden]="selectOpen">{{ item.name }}</span>
    </button>
  </ng-template>

  <ng-template ng-header-tmp="ng-header-tmp">
    <a
      class="new-project"
      *ngIf="user.admin"
      href="/users/{{ user.id }}/edit?project_modal=1"
      target="_self"
    >
      + Add new project
    </a>
  </ng-template>
</ng-select>

<ab-onboarding-callout
  [className]="'CreateSecondProject'"
  [project]="project"
  [user]="user"
></ab-onboarding-callout>
<ab-onboarding-callout
  [className]="'NameFirstProject'"
  [project]="project"
></ab-onboarding-callout>
